import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "chapter inputs column !sm:pt-6 !pt-8 flex items-center" }
const _hoisted_2 = { class: "narocanje-list" }
const _hoisted_3 = { class: "narocanje-item" }
const _hoisted_4 = { class: "row sm:mt-5 mt-1" }
const _hoisted_5 = { class: "label" }
const _hoisted_6 = { class: "label" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "textarea-guides" }
const _hoisted_9 = ["rows"]
const _hoisted_10 = { class: "label" }
const _hoisted_11 = { class: "row items-center sm:mt-6 mt-2" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "chapter sending" }
const _hoisted_15 = { class: "icon" }
const _hoisted_16 = { class: "chapter sent" }
const _hoisted_17 = { class: "icon" }

import { ref, computed, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { phoneNumber } from '@/constants'
import { isValidEmail } from '@/utils/utils'
import { currentPageId } from '@/utils/analytics'
import IconBack from '@/icons/IconBack.vue'
import EmailReceivedIcon from '@/icons/emailReceivedIcon.vue'
import EmailSendingIcon from '@/icons/emailSendingIcon.vue'
import commentIcon from '@/icons/commentIcon.vue'

type Section = 'name' | 'email' | 'message'

const debug = false


export default /*@__PURE__*/_defineComponent({
  __name: 'ContactForm',
  props: {
    mode: {}
  },
  setup(__props: any) {



const { t, locale } = useI18n()

const messageElement = ref<HTMLElement | null>(null)

const name = ref(debug ? 'Jan' : '')
const email = ref(debug ? 'jan@gmail.com' : '')
const message = ref(debug ? 'Gremo mi po svoje. Gremo mi po svoje.' : '')
const wiggling = ref(false)
const sending = ref(false)
const successfullySent = ref(false)

const validationError = ref<{ [key in Section]: string }>({
    name: '',
    email: '',
    message: '',
})

onMounted(autoResizeMessageElement)

const anyError = computed(() => Object.values(validationError.value).some(error => error !== ''))

async function wait(delay: number): Promise<void> {
    return new Promise(resolve => {
        setTimeout(resolve, delay)
    })
}

async function sendEmail() {
    const payload = {
        name: name.value,
        body: message.value,
        email: email.value,
        // The form exists twice at once on the home page - once inline and once
        // inside an open article modal - so the server cannot infer the page.
        pageId: currentPageId(),
        lang: locale.value,
    }

    validateForm()
    if (anyError.value || sending.value || successfullySent.value) {
        return
    }

    sending.value = true

    try {
        const response = await fetch('https://socutnozobozdravstvo.si/api/send-email', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        })

        await wait(1500) // Wait animation

        // Debug:
        // const response = { ok: true, status: '' }

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`)
        }

        successfullySent.value = true
    } catch (error) {
        console.error('Error sending email:', error)
        alert(t('contactForm.errors.sendFailed', { phone: phoneNumber }))
    } finally {
        sending.value = false
    }
}

function validateForm(): void {
    clearErrors()

    if (!name.value) {
        validationError.value.name = t('contactForm.errors.nameRequired')
    } else if (name.value.length < 2) {
        validationError.value.name = t('contactForm.errors.nameTooShort')
    } else if (name.value.length > 100) {
        validationError.value.name = t('contactForm.errors.nameTooLong')
    } else if (!email.value) {
        validationError.value.email = t('contactForm.errors.emailRequired')
    } else if (!isValidEmail(email.value)) {
        validationError.value.email = t('contactForm.errors.emailInvalid')
    } else if (email.value.length < 5) {
        validationError.value.email = t('contactForm.errors.emailTooShort')
    } else if (email.value.length > 90) {
        validationError.value.email = t('contactForm.errors.emailTooLong')
    } else if (!message.value) {
        validationError.value.message = t('contactForm.errors.messageRequired')
    } else if (message.value.length < 30) {
        validationError.value.message = t('contactForm.errors.messageTooShort')
    } else if (message.value.length > 5000) {
        validationError.value.message = t('contactForm.errors.messageTooLong')
    }

    wiggling.value = true
    setTimeout(() => {
        wiggling.value = false
    }, 500)
}

function clearErrors() {
    Object.keys(validationError.value).forEach(section => {
        // @ts-expect-error section is string
        validationError.value[section] = ''
    })
}

function autoResizeMessageElement() {
    if (!messageElement.value) return
    messageElement.value.addEventListener('input', function callback(): void {
        this.style.height = 'auto'
        this.style.height = `${this.scrollHeight}px`
    })
}

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["form outlined", { sending: sending.value, 'successfully-sent': successfullySent.value, compact: __props.mode === 'compact' }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (__props.mode !== 'compact')
            ? (_openBlock(), _createBlock(commentIcon, {
                key: 0,
                class: "mx-3 opacity-70"
              }))
            : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "default")
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("label", {
          class: _normalizeClass(["field", { error: validationError.value.name, wiggle: validationError.value.name && wiggling.value }]),
          for: "contact-form-name"
        }, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((name).value = $event)),
            id: "contact-form-name",
            type: "text",
            placeholder: " ",
            onKeydown: clearErrors
          }, null, 544), [
            [_vModelText, name.value]
          ]),
          _createElementVNode("span", _hoisted_5, _toDisplayString(validationError.value.name || _ctx.$t('contactForm.namePlaceholder')), 1)
        ], 2),
        _createElementVNode("label", {
          class: _normalizeClass(["field", { error: validationError.value.email, wiggle: validationError.value.email && wiggling.value }]),
          for: "contact-form-email"
        }, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((email).value = $event)),
            id: "contact-form-email",
            type: "email",
            placeholder: " ",
            onKeydown: clearErrors
          }, null, 544), [
            [_vModelText, email.value]
          ]),
          _createElementVNode("span", _hoisted_6, _toDisplayString(validationError.value.email || _ctx.$t('contactForm.emailPlaceholder')), 1)
        ], 2)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("label", {
          class: _normalizeClass(["field", { error: validationError.value.message, wiggle: validationError.value.message && wiggling.value }]),
          for: "contact-form-description"
        }, [
          _createElementVNode("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(new Array(20), (_) => {
              return (_openBlock(), _createElementBlock("div", { key: _ }))
            }), 128))
          ]),
          _withDirectives(_createElementVNode("textarea", {
            id: "contact-form-description",
            ref_key: "messageElement",
            ref: messageElement,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((message).value = $event)),
            rows: __props.mode === 'compact' ? 2 : 3,
            placeholder: " ",
            onKeydown: clearErrors
          }, null, 40, _hoisted_9), [
            [_vModelText, message.value]
          ]),
          _createElementVNode("span", _hoisted_10, _toDisplayString(validationError.value.message || _ctx.$t('contactForm.messagePlaceholder')), 1)
        ], 2)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_a_button, {
          class: "max-w-40",
          color: "pale",
          onClick: sendEmail
        }, {
          default: _withCtx(() => [
            (!successfullySent.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('contactForm.send')), 1),
                  _createVNode(IconBack, { size: 20 })
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.$t('contactForm.sent')), 1))
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createVNode(EmailSendingIcon)
      ]),
      _createElementVNode("span", null, _toDisplayString(_ctx.$t('contactForm.sending')), 1)
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("span", null, [
        _createElementVNode("div", _hoisted_17, [
          _createVNode(EmailReceivedIcon)
        ]),
        _createElementVNode("b", null, _toDisplayString(_ctx.$t('contactForm.successTitle')), 1),
        _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
        _createElementVNode("small", null, _toDisplayString(_ctx.$t('contactForm.successSubtitle')), 1)
      ])
    ])
  ], 2))
}
}

})